import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		navBarMinimised: false,
		navBarModalActive: false,
		lastUsedDate: "Today",
		workspaceItems: [{id: 1,start_time: '',end_time: '',}],
		templateDates: [{day: 'Today', date: '10 Feb', active: true},{day: 'Sat', date: '9 Feb', active: false},{day: 'Fri', date: '8 Feb', active: false},{day: 'Thu', date: '7 Feb', active: false},{day: 'Wed', date: '6 Feb', active: false},{day: 'Tue', date: '5 Feb', active: false},{day: 'Mon', date: '4 Feb', active: false},{day: 'Sun', date: '3 Feb', active: false},{day: 'Sat', date: '2 Feb', active: false},{day: 'Fri', date: '1 Feb', active: false},{day: 'Thu', date: '31 Jan', active: false},{day: 'Wed', date: '30 Jan', active: false},{day: 'Tue', date: '29 Jan', active: false},{day: 'Wed', date: '28 Jan', active: false},{day: 'Tue', date: '27 Jan', active: false},{day: 'Mon', date: '26 Jan', active: false},{day: 'Sun', date: '25 Jan', active: false},{day: 'Sat', date: '24 Jan', active: false},{day: 'Fri', date: '23 Jan', active: false},{day: 'Thu', date: '22 Jan', active: false},{day: 'Wed', date: '21 Jan', active: false},{day: 'Tue', date: '20 Jan', active: false},{day: 'Mon', date: '19 Jan', active: false},{day: 'Sun', date: '18 Jan', active: false},{day: 'Sat', date: '17 Jan', active: false},{day: 'Fri', date: '16 Jan', active: false},{day: 'Thu', date: '15 Jan', active: false}],
		mel1Patients: [],
		mel1Groups: [],
		mel1PatientOrGroupAdded: 'none',
		mel1BillingItems: [{code: '33761', active: false, templated: true},{code: '33707', active: false, templated: true},{code: '33706', active: false, templated: true},{code: '33710', active: false, templated: true},{code: '33712', active: false, templated: true}],
		mel1Diagnoses: [{code: '4334', active: false, templated: true},{code: '4340', active: false, templated: true}],
		mel1ServiceLocations: [{code: 'P', name: 'Hospital outpatient', active: true, templated: true},{code: 'I', name: 'Hospital inpatient', active: false, templated: true},{code: 'T', name: 'Practitioner\'s office, in publically administered facility', active: false, templated: false},{code: 'R', name: 'Patient\'s private home', active: false, templated: false},{code: 'A', name: 'Practitioner\'s office, in community', active: false, templated: false}],
		mel1Physicians: [{id: 89203, active: false, templated: true},{id: 89206, active: false, templated: true}],
		mel1BillingItemsSlideUpTab2: [33705,33706,33707,33708,33709,33710,33712,33713,33714,33715,33723,33730,33732,33736,33737,33738,33750,33751,33752,33756,33758,33759,33761,33790,77380,77385],
		mel1DiagnosesSlideUpTab2: [4334],
		obs1BillingItems: [{code: '04008', active: true},{code: '04010', active: false},{code: '04039', active: false},{code: '04017', active: false},{code: '04092', active: false},{code: '04018', active: false},{code: '04026', active: false}],
  },
  mutations: {
		decrementDate() {
      if ( this.state.lastUsedDate == "Today" ) {
				var date = new Date();
				date.setDate(date.getDate() - 1);

				var day = date.toLocaleString('en-us', { day: 'numeric' });
				var month = date.toLocaleString('en-us', { month: 'short' });
				var year = date.toLocaleString('en-us', { year: 'numeric' });

				this.state.lastUsedDate = day + " " + month + " " + year;

      } else {

				var $newDate = new Date(this.state.lastUsedDate);
				$newDate.setDate($newDate.getDate() - 1);

				var newDay = $newDate.toLocaleString('en-us', { day: 'numeric' });
				var newMonth = $newDate.toLocaleString('en-us', { month: 'short' });
				var newYear = $newDate.toLocaleString('en-us', { year: 'numeric' });

				this.state.lastUsedDate = newDay + " " + newMonth + " " + newYear;
      }
		},
		incrementDate() {
      if ( this.state.lastUsedDate != "Today" ) {
				var $today = new Date();
				var todayDay = $today.toLocaleString('en-us', { day: 'numeric' });
				var todayMonth = $today.toLocaleString('en-us', { month: 'short' });
				var todayYear = $today.toLocaleString('en-us', { year: 'numeric' });

				$today = todayDay + " " + todayMonth + " " + todayYear;
				
				var $currentDate = new Date(this.state.lastUsedDate);

				$currentDate.setDate($currentDate.getDate() + 1)

				var nextDay = $currentDate.toLocaleString('en-us', { day: 'numeric' });
				var nextMonth = $currentDate.toLocaleString('en-us', { month: 'short' });
				var nextYear = $currentDate.toLocaleString('en-us', { year: 'numeric' });

				var $nextString = nextDay + " " + nextMonth + " " + nextYear;

				if ( $today == $nextString ) {
					this.state.lastUsedDate = 'Today';
				} else {
					this.state.lastUsedDate = $nextString;
				}
      }
		},
		navBarMinimised(state, $state) {
			this.state.navBarMinimised = $state;
		},
		navBarModalActive(state, $state) {
			this.state.navBarModalActive = $state;
		},
		modifyWorkspaceItems(state, $count) {
			var patient = {
				id: this.state.workspaceItems.length + $count,
				start_time: '',
				end_time: '',
			}
			this.state.workspaceItems.push(patient);
		},
		addStartTime(state, payload) {
			var $index = this.state.workspaceItems.findIndex(
        element => element.id == payload.patientId
      );

      this.state.workspaceItems[$index].start_time = payload.time;
		},
		addEndTime(state, payload) {
			var $index = this.state.workspaceItems.findIndex(
        element => element.id == payload.patientId
      );

      this.state.workspaceItems[$index].end_time = payload.time;
		},
		selectDate(state, $cell) {
			this.state.templateDates.forEach((item) => {
				item.active = false;
      });

      $cell.active = true;
		},
		selectMel1ServiceLocation(state, $cell) {
			this.state.mel1ServiceLocations.forEach((item) => {
				item.active = false;
      });

      $cell.active = true;
		},
		selectMel1ReferringPhysician(state, $physician) {
			this.state.mel1Physicians.forEach((item) => {
				item.active = false;
      });

      $physician.active = true;
		},
		mel1AddPatientToClaim(state, $id) {
			var patient = {
				id: $id,
				active: true,
			};
			this.state.mel1Patients.push(patient);
		},
		mel1RemovePatientFromClaim(state, $id) {
			var $index = this.state.mel1Patients.findIndex(
        element => element.id == $id
      );

			this.state.mel1Patients.splice($index, 1);
		},
		mel1AddGroupToClaim(state, $id) {
			var group = {
				id: $id,
				active: true,
			};
			this.state.mel1Groups.push(group);
		},
		mel1RemoveGroupFromClaim(state, $id) {
			var $index = this.state.mel1Groups.findIndex(
        element => element.id == $id
      );
			this.state.mel1Groups.splice($index, 1);
		},
  },
  actions: {

  }
})
